import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AngularFireAuth } from 'angularfire2/auth';

@Injectable()
export class CustomInterceptor implements HttpInterceptor {

    constructor(private angularFireAuth: AngularFireAuth) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const tokenWasCreated = localStorage.getItem('tokenWasCreated');
        const refreshEvery = 1000 * 60 * 60;
        if (this.angularFireAuth.auth.currentUser &&
            (!tokenWasCreated || new Date().getTime() - new Date(tokenWasCreated).getTime() > refreshEvery)) {
            return Observable
                .fromPromise(this.angularFireAuth.auth.currentUser.getIdToken(true))
                .flatMap(decodedToken => {
                    localStorage.setItem('token', decodedToken);
                    localStorage.setItem('tokenWasCreated', new Date().toString());
                    return next.handle(req.clone({ headers: req.headers.set('Authorization', decodedToken) }));
                });

        } else {
            return next.handle(req);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/custom.interceptor.ts